/**
 * A page from an OLDER deploy asking for a code chunk the server no longer has.
 *
 * Every deploy replaces the app's chunks (their names are content hashes), and
 * a page loaded before it — the phone app's web view kept in the background,
 * a tab left open — still asks for the old names when it opens a lazy screen.
 * The import 404s; the screen's `Suspense` waits forever on nothing and the
 * page stays BLACK (the iPhone app on staging, 2026-10-10). Vite reports such
 * a failure as `vite:preloadError`; the cure is the new page: reload, ONCE.
 *
 * A reload that fails again within a minute is not repeated — a real outage
 * must not become a reload loop; the error then reaches the error screens.
 */
const KEY = 'myrave:platform:stale-build-reload';
const WINDOW_MS = 60_000;

export function reloadOnceForNewBuild(now = Date.now(), reload = () => window.location.reload()): boolean {
  try {
    const last = Number(sessionStorage.getItem(KEY) ?? 0);
    if (now - last < WINDOW_MS) return false;
    sessionStorage.setItem(KEY, String(now));
  } catch {
    // No storage (a locked-down web view): reload anyway — at worst once per load.
  }
  reload();
  return true;
}

export function followNewBuilds(): void {
  window.addEventListener('vite:preloadError', (event) => {
    if (reloadOnceForNewBuild()) event.preventDefault();
  });
}
